import {
  drawPointsAnim,
  drawAngleAnim,
  drawLineAnim,
  drawCircleAnim,
  rotateCircleAnim,
  movePointAnim
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";

import { INITIAL_RADIANS } from "../../types/Config";
import { normalizeRadian } from "../../../../../../src/utils/math/normalizeRadian";
import { ContextType } from "../../types/Interface";


export async function runCircleAnimation(context:ContextType, onComp: () => void) {
  const {
    circle,
    LineManager,
    PointManager,
    AngleManager,
    cCoord,
  } = context;

  const centerPoint = PointManager.getPoints()[0];
  const pointsCoord = PointManager.getRedPointsCoord();
  const RedPoints = PointManager.getRedPoints();

  const initialRadian = PointManager.getInitialRadians();
  const angles = AngleManager.getAngles();

  AngleManager.draw(pointsCoord, true);
  circle.setRadians([INITIAL_RADIANS[0], INITIAL_RADIANS[0]]);


  drawPointsAnim([centerPoint]);
  await drawCircleAnim(circle, INITIAL_RADIANS[0] + Math.PI * 2, 0, true, cCoord);

  await drawLineAnim(LineManager.lines[2], pointsCoord[0], pointsCoord[2]);
  await drawLineAnim(LineManager.lines[1], pointsCoord[2], pointsCoord[1]);
  await drawLineAnim(LineManager.lines[0], pointsCoord[1], pointsCoord[0]);


  await drawAngleAnim(angles[0], "90");
  circle.setRadians([INITIAL_RADIANS[0], INITIAL_RADIANS[1], INITIAL_RADIANS[0]])
  await drawCircleAnim(circle, INITIAL_RADIANS[2], 2, false, cCoord)

  const pointAnimArr: number[] = [
    -Math.PI / 3,
    Math.PI / 4 * 3,
    PointManager.getInitialRadians()[1]
  ]

  for (let index = 0; index < pointAnimArr.length; index++) {
    const nextRadian = pointAnimArr[index];
    const currRadian = pointAnimArr[index != 0 ? index - 1 : pointAnimArr.length - 1]
    await movePointAnim(currRadian, nextRadian, (radian) => PointManager.setRadian([{ pTag: RedPoints[1].tag, radian }]))
  }

  await rotateCircleAnim((v) => {
    const arr = Array(3).fill(v).map((v, vI) => ({ pTag: RedPoints[vI].tag, radian: normalizeRadian(initialRadian[vI] + v) }));
    PointManager.setRadian(arr)
  });

  onComp();
}